export default __webpack_public_path__ + "static/media/FiraSansExtraCondensed-Light.e3690ef4.ttf";